module.exports = __webpack_public_path__ + "static/karussel7-69477b685fa7ee2f76769dc98e2dc855.jpg";